
import { getToken } from "../utils/storage";

const BASE_URL = process.env.REACT_APP_API_URL || "";

export async function apiFetch(endpoint, options = {}) {
    const token = getToken();

    const response = await fetch(`${BASE_URL}${endpoint}`, {
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...(options.headers || {}),
        },
    });

    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Error en la solicitud");
    }

    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
        return response.json();
    }

    return response.blob();
}